// Grid template for requirements rows and header.
// Columns: checkbox | expand | name | description | themes | priority | status | assignees | evidence | completeness
// Hidable: description, themes, priority, status, assignee, evidence, personas, completeness

export function gridTemplate(visibleColumns: Record<string, boolean>): string {
  const cols = ['32px', '22px', 'minmax(280px,1fr)']
  if (visibleColumns.description !== false) cols.push('minmax(180px,2fr)')
  if (visibleColumns.themes !== false) cols.push('minmax(140px,1fr)')
  if (visibleColumns.priority !== false) cols.push('100px')
  if (visibleColumns.status !== false) cols.push('116px')
  if (visibleColumns.assignee !== false) cols.push('88px')
  if (visibleColumns.evidence !== false) cols.push('110px')
  if (visibleColumns.completeness !== false) cols.push('92px')
  return cols.join(' ')
}

export interface HeaderColumn {
  key: string
  label: string
}

export const COLUMN_HEADERS: HeaderColumn[] = [
  { key: 'description', label: 'Description' },
  { key: 'themes', label: 'Themes' },
  { key: 'priority', label: 'Priority' },
  { key: 'status', label: 'Status' },
  { key: 'assignee', label: 'Assignees' },
  { key: 'evidence', label: 'Evidence' },
  { key: 'completeness', label: 'Template' },
]
